// Allow vertical scroll to bubble up from horizontally scrollable gallery
export function enableHorizontalScrollBubble(selector = '.blocks__gallery__media') {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(selector).forEach(el => {
      el.addEventListener('wheel', function(e) {
        // Only handle horizontal scroll if the container actually overflows
        if (el.scrollWidth <= el.clientWidth) {
          // No horizontal overflow, do nothing
          return;
        }
        // Only handle horizontal scroll (deltaX > deltaY)
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 0) {
          const atStart = el.scrollLeft === 0;
          const atEnd = Math.abs(el.scrollLeft + el.clientWidth - el.scrollWidth) < 2;
          // Only scroll if not at the edge in the direction of scroll
          if ((e.deltaX < 0 && !atStart) || (e.deltaX > 0 && !atEnd)) {
            e.preventDefault();
            el.scrollLeft += e.deltaX;
          }
          // If at edge, let event bubble up (do nothing)
        }
        // For vertical scroll, always let it bubble up (never preventDefault)
      }, { passive: false });
    });
  });
}

// Auto-enable if not using modules
if (typeof module === 'undefined') {
  enableHorizontalScrollBubble();
}
